"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataCard = void 0;
var DataCard_style_1 = __importDefault(require("./DataCard.style"));
function useDataCard(_a) {
    var height = _a.height, mode = _a.mode;
    var isCompactLarge = mode === 'compactLarge';
    var isCompact = mode === 'compact';
    var isSearch = mode === 'search';
    var isSelect = mode === 'select';
    var isSearchOrSelect = isSearch || isSelect;
    var isCompactOrCompactLarge = isCompact || isCompactLarge;
    var skeletonWidth = (function () {
        if (isSearch) {
            return '25%';
        }
        if (isCompactOrCompactLarge || isSelect) {
            return '100%';
        }
        return '33%';
    })();
    var effectiveHeight = (function () {
        if (height) {
            return height;
        }
        if (isCompactLarge) {
            return 112;
        }
        if (isCompact) {
            return 78;
        }
        if (isSelect) {
            return 88;
        }
        if (isSearch) {
            return 124;
        }
        return 172;
    })();
    return {
        classes: (0, DataCard_style_1.default)(),
        effectiveHeight: effectiveHeight,
        isCompact: isCompact,
        isCompactLarge: isCompactLarge,
        isCompactOrCompactLarge: isCompactOrCompactLarge,
        isSearch: isSearch,
        isSearchOrSelect: isSearchOrSelect,
        isSelect: isSelect,
        skeletonWidth: skeletonWidth,
    };
}
exports.useDataCard = useDataCard;
